import { render, staticRenderFns } from "./simDeleteRecord.vue?vue&type=template&id=7a6fff3f&scoped=true&"
import script from "./simDeleteRecord.vue?vue&type=script&lang=js&"
export * from "./simDeleteRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6fff3f",
  null
  
)

export default component.exports